import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core';

import moment from 'moment';

import PropTypes from 'prop-types';

// import { heightUnits, weightUnits } from '../../../utils/constants';

import translations from '../../../languages/i18n';

export default function PatientDetailsView({ extended, patientData }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label='user details table'>
        <TableBody>
          <TableRow>
            <TableCell><strong>{translations['_username']}</strong></TableCell>
            <TableCell align='left'>{patientData && patientData.username}</TableCell>
          </TableRow>
          {/*
          {extended && (
            <TableRow>
              <TableCell><strong>{translations['_email']}</strong></TableCell>
              <TableCell align='left'>{patientData && patientData.email}</TableCell>
            </TableRow>
          )}
          */}
          <TableRow>
            <TableCell><strong>{translations['_birthdate']}</strong></TableCell>
            <TableCell align='left'>{patientData && patientData.birthdate && moment(patientData.birthdate).format('DD-MM-YYYY')}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>{translations['_sex']}</strong></TableCell>
            <TableCell align='left'>{patientData && patientData.sex && (patientData.sex === 'M' ? translations['_man'] : patientData.sex === 'W' ? translations['_woman'] : translations['_otherSex'])}</TableCell>
          </TableRow>
          {/*
          {extended && (
            <TableRow>
              <TableCell><strong>{translations['_height']}</strong></TableCell>
              <TableCell align='left'>{patientData && patientData.height} {heightUnits}</TableCell>
            </TableRow>
          )}
          {extended && (
            <TableRow>
              <TableCell><strong>{translations['_weight']}</strong></TableCell>
              <TableCell align='left'>{patientData && patientData.weight} {weightUnits}</TableCell>
            </TableRow>
          )}
          */}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

// Indica i controla els props que se han de passar al component
PatientDetailsView.propTypes = {
  extended: PropTypes.bool.isRequired,
  patientData: PropTypes.object.isRequired,
};
